import styled from '@emotion/styled';

interface Props {
  vertical: boolean;
}

const ButtonGroup = styled.div<Props>`
  display: flex;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  
  & > :not(:last-child):not(:first-child) {
    border-radius: unset;
    border-left: none;
  }

  & > :first-child {
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
  }

  & > :last-child {
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
    border-left: none;
  }
`;


export default ButtonGroup;
